'use strict'

import React, { PropTypes }    from 'react'
import $                       from 'jquery'
import Notifications, {notify} from 'react-notify-toast'
import FlowForm                from './assets/flow-form'
import FlowForm2               from './assets/flow-form2'
import Header                  from './assets/header'
import FrontPage               from './assets/front-page'
import Footer                  from './assets/footer'
import FindPage                from './assets/find-page'
import ProcedureType           from './form-segments/procedure-type'
import LastVisit               from './form-segments/last-visit'
import Smoker                  from './form-segments/smoker'
import FullSummaryPage         from './form-segments/full-summary-page'
import FormLanding             from './form-segments/form-landing'
import DentalHistory           from './form-segments/dental-history'
import YourDetails             from './form-segments/your-details'
import Agreement               from './form-segments/agreement'
import YourPreference          from './form-segments/your-preference'
import PaymentDetails          from './form-segments/payment-details'
import ReCAPTCHA               from 'react-google-recaptcha'

const errorTime = 10000

export default class Main extends React.Component {
  getChildContext() {
    return {
      optimizelyToken: this.optimizelyToken,
      termsAndConditions: this.termsAndConditions,
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      summary: {},
      introPage: true,
      firstForm: true,
      findPage: false,
      currentPage: 0,
      captcha: null
    }

    this.optimizelyToken = '8385414930';
    this.termsAndConditions = [
      "DMA packages are only available through DMA call center representatives and online purchases",
      "All treatment will be provided by our selected DMA partner Dentists or Hygienists where appropriate",
      "A $38 initial one off registration fee is payable upon joining",
      "DMA vouchers can be used to pay gap payments for health fund members to the value of the voucher",
      "Please be advised that for treatment that exceeds the value of the voucher the difference in dollar value is payable on the day of treatment at the practice.",
      "Further Care Plan Discounts don't apply to the voucher",
      "The practice usual fees applies to the value of the voucher not the Care Plan fees schedule",
      "A $10 fee will be payable on missed direct debit payments which are not paid within 5 days to the practice",
      "There are no lock in contracts and if the total amount of voucher value is not used it will remain in credit until used",
      "Funds are not refunded unless there has been no dental treatment started",
      "You can start your dental treatment only after your successful second payment",
      "Treatment will be spread across the term of your package as agreed with your dental practitioner",
      "Direct Debit Payments must be up to date for scheduled appointments to proceed.",
      "Capped Fee Pricing available at select DMA partner dental practices.",
    ]

    this.updateSummary = this.updateSummary.bind(this)
    this.secondFlowNextPage = this.secondFlowNextPage.bind(this)
    this.showSecondForm = this.showSecondForm.bind(this)
    this.startForm = this.startForm.bind(this)
    this.showFindPage = this.showFindPage.bind(this)
    this.emailForm = this.emailForm.bind(this)
    this.captcha = this.captcha.bind(this)
    this.showIntroPage = this.showIntroPage.bind(this)
  }

  startForm (){
    window.scrollTo(0, 0)

    window.ga('send', 'event', {
      eventCategory: 'H – Fast Quote',
      eventAction: 'Click',
      eventLabel: 'Fast Quote'
    })

    this.setState({
      introPage: false
    })
  }

  sanitizeFormData (formData) {
    let sanitizedFormData = {}
    let ccDetails = [
      'agreement',
      'card-type',
      'card-number',
      'card-expiry'
    ]

    Object.keys(formData).forEach((key) => {
      if (ccDetails.indexOf(key) < 0) {
        let property = formData[key].displayName
        let value = formData[key].value
        sanitizedFormData[property] = value
      }
    })

    return sanitizedFormData
  }

  emailForm () {
    $.ajax({
      url: 'https://formsend.io/f/s6qrzqxk',
      method: 'POST',
      data: this.sanitizeFormData(this.state.summary),
      dataType: 'json'
    })
  }

  redirect () {
    window.location.href = `/Thankyou-DentalVoucherPatient?location=${this.state.summary['location'].value}`
  }

  submit (button) {
    const { summary, captcha } = this.state

    let voucher =
      `voucher_${
        summary['dental-package'].value.replace(/\$|,/g, '')
        }_${
        summary['dental-package'].weeklyPayment.replace('$', '')
        }`

    let data = {
      'plan': {
        'prospect_id': summary['prospect-id'].value,
        'payment_time_unit': summary['payment-frequency'].value.toLowerCase(),
        'start_day': summary['first-payment-date'].value.split('/')[0],
        'start_month': summary['first-payment-date'].value.split('/')[1],
        'start_year': summary['first-payment-date'].value.split('/')[2],
        'credit_card_number': summary['card-number'].value.join(''),
        'credit_card_month': summary['card-expiry'].value[0],
        'credit_card_year': summary['card-expiry'].value[1],
        'credit_card_name': summary['full-name'].value,
        'postcode': summary['location'].value,
        'voucher': voucher
      },
      'g-recaptcha-response': captcha
    }

    $.ajax({
      method: 'POST',
      url: '/voucher_signup',
      data: data,
      dataType: 'JSON',
      success: (data) => {
        if (!data.errors) {
          window.ga('send', 'event', {
            eventCategory: 'Confirmation',
            eventAction: 'Purchase',
            eventLabel: 'Online Purchase',
            eventValue: summary['dental-package'].weeklyPayment.replace('$', '')
          })

          window['optimizely'] = window['optimizely'] || []
          window.optimizely.push(['trackEvent', 'SuccessfulVoucher'])

          this.redirect()
        }
      },
      error: (xhr) => {
        const error = xhr.responseJSON ? xhr.responseJSON.errors : 'Failed to send.'
        notify.show(error, 'error', errorTime)
        button.disabled = false
        button.innerHTML = 'Try Again'
      }
    })
  }

  prospect (cont, button, e) {
    let {summary} = this.state

    let voucher =
      `voucher_${
        summary['dental-package'].value.replace(/\$|,/g, '')
        }_${
        summary['dental-package'].weeklyPayment.replace('$', '')
        }`

    this.setState({
      currentPage: ++this.state.currentPage
    })

    let data = {
      'prospect': {
        'id': summary['prospect-id'] ? summary['prospect-id'].value : undefined,
        'name': `${summary['first-name'].value} ${summary['last-name'].value}`,
        'email': summary['contact-email'].value,
        'phone': summary['contact-number'].value,
        'postcode': summary['location'].value,
        'practice_slug': summary['dentist'] ? summary['dentist'].slug : undefined,
        'dental_voucher': voucher
      },

      'questions': {
        'Have you been to the dentist in the past 12 month?': summary['last-visit'].value,
        'Is there specific dental treatment you know you need?': summary['know-whats-needed'].value,
        'Smoke': summary['smoker'] ? summary['smoker'].value : undefined
      }
    }

    $.ajax({
      method: 'POST',
      url: '/add_prospect',
      data: data,
      dataType: 'JSON',
      success: (data) => {
        if (!data.errors) {
          let prospect = JSON.parse(data.prospect).prospect
          summary['prospect-id'] = {
            value: prospect.id
          }
          button.disabled = false
          button.innerHTML = 'continue'
          cont(true, e)
        }
      },
      error: (xhr) => {
        if (xhr.responseJSON && xhr.responseJSON.no_practice) {
          window.location = '/submitted-treatment-enquiry?location=4006&no_practice=true'
        } else {
          const error = xhr.responseJSON ? xhr.responseJSON.errors : 'Failed to send.'
          notify.show(error, 'error', errorTime)
          button.disabled = false
          button.innerHTML = 'Try Again'
        }
      }
    })
  }

  showSecondForm () {
    window.scrollTo(0, 0)

    this.pages()

    this.setState({
      introPage: false,
      firstForm: false,
      findPage: false
    })
  }

  showFindPage () {
    window.scrollTo(0, 0)

    this.setState({
      introPage: false,
      firstForm: false,
      findPage: true
    })

    window.ga('send', 'event', {
      eventCategory: 'H - Local Dentist',
      eventAction: 'Click',
      eventLabel: 'Find a Local Dentist'
    })
  }

  showIntroPage () {
    window.scrollTo(0, 0)

    this.setState({
      introPage: true,
      firstForm: false,
      findPage: false
    })
  }

  updateSummary (key, changedProp) {
    let currentProps = this.state.summary
    currentProps[key] = changedProp

    this.setState({
      summary: currentProps
    })
  }

  secondFlowNextPage (e) {
    e && e.preventDefault()

    const {currentPage} = this.state

    let nextPage = currentPage

    if (nextPage < this.secondFlowPages().length - 1) {
      nextPage++
    } else {
      this.showSecondForm()
    }

    this.setState({
      currentPage: nextPage
    }, () => {
      setTimeout(() => {
        let highest = 0
        let highestEl = null

        $('.flow-form2').find('label.button').each(function (i) {
          if ($(this).height() > highest) {
            highest = $(this).height()
            highestEl = this
          }
        })

        $('.flow-form2').find('label.button').not(highestEl).height(highest).show()
      }, 1)
    })
  }

  welcome () {
    return (
      <div className='form-landing'>
        <FormLanding summary={this.state.summary} onChange={this.updateSummary} />
      </div>
    )
  }

  yourDetails () {
    return (
      <div className='your-details'>
        <DentalHistory summary={this.state.summary} onChange={this.updateSummary} />
        <p className='info-box'>
          40,000 patients have been helped by Dental Members Australia.
        </p>
        <YourDetails onChange={this.updateSummary} summary={this.state.summary} />
      </div>
    )
  }

  yourPreference () {
    return (
      <div className='your-preference'>
        <YourPreference summary={this.state.summary} onChange={this.updateSummary} />
      </div>
    )
  }

  captcha (response) {
    this.setState({
      captcha: response
    });
  }

  yourPayment () {
    return (
      <div className='your-payment'>
        <PaymentDetails summary={this.state.summary} onChange={this.updateSummary} />
        <div className="recaptcha">
          <ReCAPTCHA
            sitekey="6LclxxUUAAAAAI1KEqGnyKKjn2wH7V2-gSWjGIQO"
            onChange={this.captcha}/>
        </div>
        <Agreement onChange={this.updateSummary} />
      </div>
    )
  }

  secondFlowPages () {
    const {summary} = this.state

    return [{
      name: 'Procedure Type',
      pageRef: 'procedure-type',
      showNext: true,
      required: ['know-whats-needed'],
      page:
        <ProcedureType
          onChange={this.updateSummary}
          summary={summary}
          />
    }, {
      name: 'Last Visit',
      pageRef: 'last-visit',
      showNext: false,
      page:
        <LastVisit
          onChange={this.updateSummary}
          nextPage={this.secondFlowNextPage}
          summary={summary}
          />
    }, {
      name: 'Smoker',
      pageRef: 'smoker',
      showNext: false,
      page:
        <Smoker
          onChange={this.updateSummary}
          nextPage={this.secondFlowNextPage}
          summary={summary}
          />
    }, {
      name: 'Full Summary',
      pageRef: 'full-summary',
      showNext: false,
      page:
        <FullSummaryPage
          onChange={this.updateSummary}
          showSecondForm={this.showSecondForm}
          summary={summary}
          />
    }]
  }

  pages () {
    const pageArr = [{
      name: 'Your Details',
      pageRef: 'your-details',
      page: this.yourDetails(),
      required: ['last-visit', 'know-whats-needed', 'full-name', 'contact-number', 'contact-email', 'location']
    }, {
      name: 'Your Preferences',
      pageRef: 'your-preference',
      page: this.yourPreference(),
      required: ['dental-package']
    }, {
      name: 'Payment',
      pageRef: 'your-payment',
      page: this.yourPayment(),
      required: ['payment-frequency', 'card-type', 'card-number', 'first-payment-date', 'agreement']
    }]

    if (!window.calculatorClick) {
      pageArr.unshift({
        name: 'Welcome',
        pageRef: 'form-landing',
        page: this.welcome(),
        required: []
      });
    }

    this.setState({
      currentPage: window.location.hash.startsWith('#page-')
        ? parseInt(window.location.hash.split('-')[1])
        : 0,
      pages: pageArr
    })
  }

  componentDidMount () {
    if (window.location.hash) {
      let firstForm = window.location.hash === '#quote'
      let findPage = window.location.hash === '#find'
      let formPage = window.location.hash === '#buy' ||
                     window.location.hash.startsWith('#page-')

      let introPage = !firstForm && !findPage && !formPage

      this.setState({
        introPage: introPage,
        firstForm: firstForm,
        findPage: findPage
      })
    }

    this.pages()
  }

  render () {
    const {summary, introPage, firstForm, findPage, currentPage} = this.state
    
    let page

    if (introPage) {
      page = (
        <FrontPage
          onChange={this.updateSummary}
          startForm={this.startForm}
          showSecondForm={this.showSecondForm}
          showFindPage={this.showFindPage} />
      )
    } else {
      if (firstForm) {
        page = (
          <div className='relative container'>
            <FlowForm2
              pages={this.secondFlowPages()}
              summary={summary}
              currentPage={currentPage}
              nextPage={this.secondFlowNextPage} />
          </div>
        )
      } else if (findPage) {
        page = (
          <FindPage onChange={this.updateSummary} showSecondForm={this.showSecondForm} />
        )
      } else {
        page = (
          <div className='relative container'>
            <FlowForm
              pages={this.state.pages}
              summary={summary}
              onPageChange={this.emailForm}
              doProspect={this.prospect.bind(this)}
              onFinish={this.submit.bind(this)}
              currentPage={currentPage}
              returnToIntro={this.showIntroPage}
            />
          </div>
        )
      }
    }

    return (
      <div className='Main'>
        <Notifications />
        {(() => {
          return (
            <Header
              startForm={this.showSecondForm}
              startQuote={this.startForm}
              startFind={this.showFindPage}
              introPage={introPage}
              findPage={findPage}
              firstForm={firstForm}
              currentPage={currentPage} />
           )
        })()}
        {page}
        {!findPage && ((!introPage && !firstForm) ? '' : <Footer />)}
      </div>
    )
  }
}

Main.childContextTypes = { 
  optimizelyToken: PropTypes.string,
  termsAndConditions: PropTypes.array,
}



// WEBPACK FOOTER //
// ./src/components/Main.js